import Header from '../components/deliver/Header';
import Hero from '../components/deliver/Hero';
import WhyDeliver from '../components/deliver/WhyDeliver';
import HowItWorks from '../components/deliver/HowItWorks';
import GetStarted from '../components/deliver/GetStarted';
import FAQ from '../components/deliver/FAQ';
import DeliverFooter from '../components/deliver/DeliverFooter';

function Deliver() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <WhyDeliver />
        <HowItWorks />
        <GetStarted />
        <FAQ />
       
      </main>
      <DeliverFooter />
    </>
  );
}

export default Deliver;
